// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var newSlot = /* #__PURE__ */ Control_Monad_Replace.newSlot(Specular_Dom_Builder.monadReplaceBuilder);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Specular_Dom_Builder.bindBuilder);
var onCleanup = /* #__PURE__ */ Control_Monad_Cleanup.onCleanup(Specular_Dom_Builder.monadCleanupBuilder);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var runWidgetInNode = function (parent) {
    return function (widget) {
        return Specular_Dom_Builder.runBuilder(parent)(bind(newSlot)(function (slot) {
            return discard1(onCleanup(Control_Monad_Replace.destroySlot(slot)))(function () {
                return liftEffect(Control_Monad_Replace.replaceSlot(slot)(widget));
            });
        }));
    };
};
var spawnWidgetInNode = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (dictMonadCleanup) {
        var Monad0 = dictMonadCleanup.Monad0();
        var Bind1 = Monad0.Bind1();
        var bind2 = Control_Bind.bind(Bind1);
        var discard2 = discard(Bind1);
        var onCleanup1 = Control_Monad_Cleanup.onCleanup(dictMonadCleanup);
        var pure = Control_Applicative.pure(Monad0.Applicative0());
        return function (node) {
            return function (widget) {
                return bind2(liftEffect1(runWidgetInNode(node)(widget)))(function (v) {
                    return discard2(onCleanup1(v.value1))(function () {
                        return pure(v.value0);
                    });
                });
            };
        };
    };
};
var spawnWidgetInBody = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    var spawnWidgetInNode1 = spawnWidgetInNode(dictMonadEffect);
    return function (dictMonadCleanup) {
        var bind2 = Control_Bind.bind((dictMonadCleanup.Monad0()).Bind1());
        var spawnWidgetInNode2 = spawnWidgetInNode1(dictMonadCleanup);
        return function (widget) {
            return bind2(liftEffect1($foreign.documentBody))(function (body) {
                return spawnWidgetInNode2(body)(widget);
            });
        };
    };
};
var runWidgetInBody = function (widget) {
    return function __do() {
        var body = $foreign.documentBody();
        return runWidgetInNode(body)(widget)();
    };
};
var runMainWidgetInNode = function (parent) {
    return function (widget) {
        return map(Data_Tuple.fst)(runWidgetInNode(parent)(widget));
    };
};
var runMainWidgetInBody = function (widget) {
    return function __do() {
        var body = $foreign.documentBody();
        return runMainWidgetInNode(body)(widget)();
    };
};
var monadWidget = function (dictMonadDomBuilder) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (dictMonoid) {
                return {
                    MonadDomBuilder0: function () {
                        return dictMonadDomBuilder;
                    },
                    MonadFRP1: function () {
                        return dictMonadFRP;
                    },
                    MonadReplace2: function () {
                        return dictMonadReplace;
                    },
                    Monoid3: function () {
                        return dictMonoid;
                    }
                };
            };
        };
    };
};
var liftWidget = function (dictMonadDomBuilder) {
    var liftBuilder = Specular_Dom_Builder_Class.liftBuilder(dictMonadDomBuilder);
    return function (w) {
        var v = Specular_Dom_Builder.unBuilder(w);
        return liftBuilder(function (env) {
            return v({
                parent: env.parent,
                cleanup: env.cleanup,
                userEnv: Data_Unit.unit
            });
        });
    };
};
var emptyWidget = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
export {
    runWidgetInNode,
    runWidgetInBody,
    runMainWidgetInNode,
    runMainWidgetInBody,
    spawnWidgetInNode,
    spawnWidgetInBody,
    liftWidget,
    emptyWidget,
    monadWidget
};
